(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ad-article"]) return;
  try {
    
  (() => {
    const body = document.querySelector('[data-ad-art-body]');
    if (!body || body.dataset.ready) return;
    body.dataset.ready = '1';

    const heads = Array.from(body.querySelectorAll('h2'));
    const slug = (s) => s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const desk = document.querySelector('[data-ad-art-toc]');
    const mob = document.querySelector('[data-ad-art-toc-m]');

    if (heads.length > 1) {
      heads.forEach((h, i) => { if (!h.id) h.id = slug(h.textContent) || 'partie-' + (i + 1); });
      [desk, mob].forEach((toc) => {
        if (!toc) return;
        const ol = toc.querySelector('ol');
        heads.forEach((h) => {
          const li = document.createElement('li');
          const a = document.createElement('a');
          a.href = '#' + h.id;
          const s = document.createElement('span');
          s.textContent = h.textContent;
          a.appendChild(s);
          li.appendChild(a);
          ol.appendChild(li);
        });
        toc.hidden = false;
      });
      if (mob) mob.addEventListener('click', (e) => { if (e.target.closest('a')) mob.open = false; });

      const links = desk ? Array.from(desk.querySelectorAll('a')) : [];
      if ('IntersectionObserver' in window && links.length) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((en) => {
            if (!en.isIntersecting) return;
            links.forEach((l) => l.classList.toggle('is-on', l.hash === '#' + en.target.id));
          });
        }, { rootMargin: '-15% 0px -70% 0px' });
        heads.forEach((h) => io.observe(h));
      }
    }

    const bar = document.querySelector('[data-ad-art-bar]');
    if (bar) {
      const on = () => {
        const r = body.getBoundingClientRect();
        const total = r.height - window.innerHeight * 0.5;
        const done = Math.min(Math.max(window.innerHeight * 0.3 - r.top, 0), Math.max(total, 0));
        bar.style.transform = 'scaleX(' + (total > 0 ? done / total : 0) + ')';
      };
      on();
      window.addEventListener('scroll', on, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ad-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-ad-news]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    const { company, list, source } = root.dataset;
    const withSms = root.dataset.sms === 'true';
    const steps = {};
    root.querySelectorAll('[data-step]').forEach((el) => { steps[el.dataset.step] = el; });
    const KEY = 'ad_news_done';
    let email = '';

    const store = {
      get() { try { return localStorage.getItem(KEY); } catch (e) { return null; } },
      set() { try { localStorage.setItem(KEY, '1'); } catch (e) {} },
    };

    const show = (name, focus) => {
      Object.keys(steps).forEach((key) => { steps[key].hidden = key !== name; });
      if (focus) {
        const target = steps[name].querySelector('.ad-foot__news-in') || steps[name].querySelector('.ad-foot__news-t');
        if (target) target.focus({ preventScroll: true });
      }
    };

    const fail = (form, message) => {
      const input = form.querySelector('.ad-foot__news-in');
      const err = form.querySelector('.ad-foot__news-err');
      if (input) input.setAttribute('aria-invalid', message ? 'true' : 'false');
      if (err) { err.textContent = message || ''; err.hidden = !message; }
    };

    const busy = (form, on) => {
      const btn = form.querySelector('.ad-foot__news-btn');
      if (!btn) return;
      btn.disabled = on;
      btn.textContent = on ? 'Un instant…' : btn.dataset.label;
    };

    const post = (path, body) =>
      fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'content-type': 'application/json', revision: '2025-01-15' },
        body: JSON.stringify(body),
      }).then((res) => { if (!res.ok) throw new Error('klaviyo ' + res.status); return res; });

    // Déjà inscrit depuis ce navigateur : on affiche directement la confirmation.
    if (store.get() && steps.done.hidden) show('done', false);

    // Sans identifiants Klaviyo, on laisse le formulaire Shopify faire son travail.
    if (!company || !list) return;

    steps.email.addEventListener('submit', (event) => {
      event.preventDefault();
      const form = steps.email;
      const value = form.querySelector('[type="email"]').value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) { fail(form, 'Cette adresse email semble incomplète.'); return; }
      fail(form, '');

      // Champ piège rempli : un robot. On confirme sans rien envoyer.
      if (form.querySelector('.ad-foot__news-hp').value) { show('done', true); return; }

      busy(form, true);
      post('subscriptions', {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source || 'FOOTER',
            profile: { data: { type: 'profile', attributes: { email: value, properties: { 'Formulaire inscription': source || 'FOOTER' } } } },
          },
          relationships: { list: { data: { type: 'list', id: list } } },
        },
      })
        .then(() => {
          email = value;
          store.set();
          if (window.klaviyo && typeof window.klaviyo.identify === 'function') { try { window.klaviyo.identify({ email: value }); } catch (e) {} }
          show(withSms ? 'sms' : 'done', true);
        })
        .catch(() => fail(form, 'Un souci de connexion. Merci de réessayer dans un instant.'))
        .finally(() => busy(form, false));
    });

    const toE164 = (raw) => {
      const v = raw.replace(/[\s.\-()]/g, '');
      if (/^0[67]\d{8}$/.test(v)) return '+33' + v.slice(1);
      if (/^(\+|00)33[67]\d{8}$/.test(v)) return '+' + v.replace(/^(\+|00)/, '');
      if (/^\+[1-9]\d{7,14}$/.test(v)) return v;
      return null;
    };

    steps.sms.addEventListener('submit', (event) => {
      event.preventDefault();
      const form = steps.sms;
      const raw = form.querySelector('[type="tel"]').value.trim();
      if (!raw) { fail(form, 'Indiquez votre numéro, ou choisissez « Non merci ».'); return; }
      const phone = toE164(raw);
      if (!phone) { fail(form, 'Ce numéro de mobile semble incomplet.'); return; }
      fail(form, '');
      busy(form, true);
      post('profiles', {
        data: {
          type: 'profile',
          attributes: {
            email,
            phone_number: phone,
            properties: {
              'Consentement SMS': true,
              'Consentement SMS date': new Date().toISOString(),
              'Consentement SMS source': source || 'FOOTER',
              'Consentement SMS mention': form.querySelector('.ad-foot__news-legal').textContent.trim(),
            },
          },
        },
      })
        .then(() => show('done', true))
        .catch(() => fail(form, 'Un souci de connexion. Merci de réessayer dans un instant.'))
        .finally(() => busy(form, false));
    });

    steps.sms.querySelector('[data-skip]').addEventListener('click', () => show('done', true));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ad-teaser"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.querySelector('.ad-tz');
    if (!el) return;
    var FORM = el.getAttribute('data-form');
    var KEY = 'adTeaser';
    var DAY = 864e5;

    function read() { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } }
    function write(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
    function openForm() { window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', FORM]); }

    if (/[?&]ad-teaser=reset/.test(location.search)) { try { localStorage.removeItem(KEY); } catch (e) {} }

    var designMode = !!(window.Shopify && window.Shopify.designMode);
    var mobile = window.matchMedia('(max-width: 768px)').matches || /[?&]ad-teaser=mobile/.test(location.search);
    var mobileLogo = el.getAttribute('data-mobile-logo') === 'true';
    var formOpen = false;
    var menuBtn = null;
    var onOpen = function () {};
    var onClose = function () {};

    window.addEventListener('klaviyoForms', function (e) {
      var d = (e && e.detail) || {};
      if (d.formId !== FORM) return;
      if (d.type === 'open') { formOpen = true; onOpen(); }
      else if (d.type === 'close') { formOpen = false; onClose(); }
      else if (d.type === 'submit' || (d.type === 'stepSubmit' && d.metaData && (d.metaData.$email || d.metaData.$phone_number))) {
        var s = read();
        s.done = 1;
        write(s);
        if (menuBtn) menuBtn.remove();
      }
    });

    if (!designMode && read().done) return;

    /* ---------- Menu mobile : entrée de l'offre en haut du menu ; la pop-up s'ouvre par-dessus, le menu reste ouvert ---------- */
    var mtpl = document.getElementById('ad-tz-menu-tpl');
    var panel = document.querySelector('.ad-drawer .ad-drawer__panel');
    if (mtpl && mtpl.content && mtpl.content.firstElementChild && panel && !panel.querySelector('.ad-tzmenu')) {
      menuBtn = mtpl.content.firstElementChild.cloneNode(true);
      var top = panel.querySelector('.ad-drawer__top');
      if (top) top.insertAdjacentElement('afterend', menuBtn); else panel.insertBefore(menuBtn, panel.firstChild);
      menuBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openForm();
      });
    }

    /* ---------- Mobile : pas d'onglet flottant ; alternance avec le logo seulement si la case est cochée ---------- */
    if (mobile) {
      document.documentElement.classList.add('ad-tzm');
      if (!mobileLogo) return;
      var hdr = document.querySelector('.ad-hdr');
      var logo = hdr && hdr.querySelector('.ad-logo');
      if (!hdr || !logo) return;

      var LOGO_MS = 8000;   /* durée d'affichage du logo entre deux apparitions */
      var OFFER_MS = 4000;  /* durée d'affichage de l'offre */
      var FIRST_MS = 3000;  /* délai avant la première apparition, une fois la page défilée */
      var MAX = 4;          /* nombre d'apparitions par page */
      var START_AT = 300;   /* défilement, en pixels, à partir duquel l'alternance démarre */

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ad-tzl';
      btn.tabIndex = -1;
      btn.setAttribute('aria-label', el.querySelector('.ad-tz__open').getAttribute('aria-label'));
      btn.innerHTML = el.querySelector('.ad-tz__open').innerHTML;
      hdr.appendChild(btn);
      btn.addEventListener('click', openForm);

      var shows = 0;
      var timer = null;
      var started = false;
      /* Sur grand écran le thème fait défiler .page-wrapper, sur mobile c'est la fenêtre : on lit les deux. */
      var wrap = document.querySelector('.page-wrapper');

      function scrolled() { return Math.max(window.scrollY || 0, wrap ? wrap.scrollTop : 0); }
      function setOn(on) { hdr.classList.toggle('ad-tzl-on', on); btn.tabIndex = on ? 0 : -1; }
      function blocked() { return formOpen || document.hidden || !!document.querySelector('.ad-drawer[open]'); }
      function cycle(delay) {
        clearTimeout(timer);
        if (read().done || shows >= MAX) { setOn(false); return; }
        timer = setTimeout(function () {
          if (blocked()) { cycle(LOGO_MS); return; }
          setOn(true);
          shows++;
          timer = setTimeout(function () { setOn(false); cycle(LOGO_MS); }, OFFER_MS);
        }, delay);
      }
      function onScroll() {
        if (started || scrolled() < START_AT) return;
        started = true;
        document.removeEventListener('scroll', onScroll, true);
        cycle(FIRST_MS);
      }

      onOpen = function () { clearTimeout(timer); setOn(false); };
      onClose = function () { if (started) cycle(LOGO_MS); };

      document.addEventListener('scroll', onScroll, true);
      onScroll();
      return;
    }

    /* ---------- Ordinateur : onglet en bas à gauche ---------- */
    var state = read();
    if (!designMode && state.hide && Date.now() < state.hide) return;

    var dismissed = false;

    function show() {
      if (formOpen || dismissed || read().done) return;
      el.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-on'); }); });
    }
    function hide() { el.classList.remove('is-on'); }

    onOpen = hide;
    onClose = show;

    el.querySelector('.ad-tz__open').addEventListener('click', openForm);

    el.querySelector('.ad-tz__x').addEventListener('click', function (e) {
      e.stopPropagation();
      dismissed = true;
      hide();
      var s = read();
      s.hide = Date.now() + 7 * DAY;
      write(s);
    });

    setTimeout(show, designMode ? 0 : 2000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
